
import { Options, Vue } from "vue-class-component";
import { KatexElement } from "@hsorby/vue3-katex";

@Options({
    props: {
        isInput: Boolean,
        isHistory: Boolean,
        rowIndex: Number,
        columnIndex: Number,
    },
    components: {
        KatexElement,
    },
})
export default class ExpressionClass extends Vue {
    isInput!: boolean;
    isHistory!: boolean;
    rowIndex!: number;
    columnIndex!: number;

    focus(): void {
        if (this.isInput) {
            this.$store.commit("SET_CURRENT_COLUMN", this.columnIndex);
        }
    }

    get cellClass(): string {
        let classes = ["cell"];
        if (this.isFocused) {
            classes.push("focused");
        } else if (this.isHistory) {
            classes.push("history");
            let guess = this.guess;
            if (guess != "") {
                classes.push(guess);
            }
        }
        return classes.join(" ");
    }

    get isFocused() {
        let currentRow = this.$store.state.currentRow;
        let currentColumn = this.$store.state.currentColumn;
        return currentRow == this.rowIndex && currentColumn == this.columnIndex;
    }

    get currentRow() {
        return this.$store.state.currentRow;
    }

    get guess(): string {
        let exp = this.expression;
        let ans = this.$store.state.answer;

        if (ans[this.columnIndex] == exp) {
            return "correct";
        }

        if (ans.indexOf(exp) > 0) {
            return "wrong-position";
        }

        return "";
    }

    get expressions(): string[][] {
        return this.$store.state.expressions;
    }

    get expression(): string {
        let expressions = this.$store.state.expressions;
        return expressions[this.rowIndex][this.columnIndex];
    }

    get isCurrentColumn(): boolean {
        return this.columnIndex == this.$store.state.currentColumn;
    }
}
